import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const $ = window.$;

class NewProductButton extends Component {

    componentDidMount() {
        $('.dropdown-btn, .dropdown-group-btn').hover(function () {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(500);
        }, function () {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(500);
        });
    }

    render() {
        return (
            <div>
                <div className="col-md-auto" style={{ width: '11.3%' }}></div>
                <div className="col-md-auto">
                    <div className="btn-group dropdown-group-btn">
                        <button type="button" className="btn title-btn green-btn">+ New Product</button>
                        <button type="button" className="btn green-btn dropdown-toggle dropdown-toggle-split" aria-haspopup="true" aria-expanded="false">
                            <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <div className="dropdown-menu">
                            <Link to={`/products/new#single`} className="dropdown-item">Single Product</Link>
                            <Link to={`/products/new#set`} className="dropdown-item">Product Set</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewProductButton;



// WEBPACK FOOTER //
// ./src/views/products/NewProductButton.jsx